export class NetworkError extends Error {
    constructor(statusCode=500, ...params) {
        super(...params)
        this.networkError = {statusCode}
    }
}
